import { render, staticRenderFns } from "./TestSync.vue?vue&type=template&id=1d81d5dd"
import script from "./TestSync.vue?vue&type=script&lang=js"
export * from "./TestSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports